var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0179 4.38031C21.9271 4.37095 21.8355 4.37095 21.7446 4.38031H3.07794C2.95831 4.38216 2.83946 4.4001 2.72461 4.43365L12.3579 14.027L22.0179 4.38031Z",
    fill: "#222835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0053 5.30701L13.2986 14.9737C13.0488 15.222 12.7109 15.3614 12.3586 15.3614C12.0064 15.3614 11.6684 15.222 11.4186 14.9737L1.79862 5.38034C1.76905 5.48903 1.75337 5.60104 1.75195 5.71367V19.047C1.75195 19.4006 1.89243 19.7398 2.14248 19.9898C2.39253 20.2399 2.73166 20.3803 3.08529 20.3803H21.752C22.1056 20.3803 22.4447 20.2399 22.6948 19.9898C22.9448 19.7398 23.0853 19.4006 23.0853 19.047V5.71367C23.08 5.57478 23.053 5.43756 23.0053 5.30701V5.30701ZM3.99862 19.047H3.07195V18.0937L7.91862 13.287L8.85862 14.227L3.99862 19.047ZM21.7386 19.047H20.8053L15.9453 14.227L16.8853 13.287L21.732 18.0937L21.7386 19.047Z",
    fill: "#222835"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0dc94498.svg";
export { ForwardRef as ReactComponent };